var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEinrichtung(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Legende_Einrichtung__Icn/40px/Legende/Einrichtung",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Legende_Einrichtung__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Legende_Einrichtung__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.0909091,8 L29,16 L29,29 L10,29 L10,16 L22.0909091,8 Z M21,11.118 L12,17.074 L12,27 L15,27 L15,22 L18,21 L18,27 L21,27 L21,11.118 Z M23,12.113 L23,27 L27,27 L27,16.744 L23,12.113 Z",
    id: ".._.._src_svg_Icn_40px_Legende_Einrichtung__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEinrichtung);
export default __webpack_public_path__ + "static/media/Einrichtung.3aa3d83a7a0df66ed23bb71d80b41aa1.svg";
export { ForwardRef as ReactComponent };